import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const UpdateMedicineForm = ({ medicineId, closeModal, onMedicineUpdated }) => {
  const [formData, setFormData] = useState({
    name: "",
    substitutes: "",
    diseases: "",
    category: "",
    stock: "",
    price: "",
    description: "",
    prescription: true,
  });
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch medicine details on mount
  useEffect(() => {
    const fetchMedicine = async () => {
      try {
        const { data } = await axios.get(`/medicines/${medicineId}`, {
          withCredentials: true,
        });

        setFormData({
          name: data.name || "",
          substitutes: (data.substitutes || []).join(", "),
          diseases: (data.diseases || []).join(", "),
          category: data.category || "",
          stock: data.stock || "",
          description: data.description || "",
          price: data.price || "",
          prescription: data.prescription?? true,
        });

        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch medicine:", error);
      }
    };

    fetchMedicine();
  }, [medicineId]);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleFileChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      form.append(key, value);
    });

    if (image) {
      form.append("image", image);
    }

    try {
      const { data } = await axios.patch(`/medicines/${medicineId}`, form, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
      });

      console.log("Medicine updated:", data);
      toast.success("Medicine updated successfully");
      onMedicineUpdated?.(data);
      closeModal();
    } catch (err) {
      console.error("Update failed:", err.response?.data?.error || err.message);
      toast.error("Failed to update medicine. Please try again.");
      if (err.response?.data?.error) {
        toast.error(err.response.data.error);
      } else {
        toast.error("An unknown error occurred.");
      }
    }
  };

  if (loading) return <p>Loading medicine data...</p>;

  return (
    <div className="modal">
      <form onSubmit={handleSubmit} className="update-form">
        <h3>Update Medicine</h3>
        <label htmlFor="name">Name</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Name"
        />
           <label htmlFor="substitutes">Substitutes</label>
        <input
          type="text"
          name="substitutes"
          value={formData.substitutes}
          onChange={handleChange}
          placeholder="Substitutes (comma-separated)"
        />
            <label htmlFor="diseases">Diseases</label>
        <input
          type="text"
          name="diseases"
          value={formData.diseases}
          onChange={handleChange}
          placeholder="Diseases (comma-separated)"
        />
            <label htmlFor="category">Category</label>
        <input
          type="text"
          name="category"
          value={formData.category}
          onChange={handleChange}
          placeholder="Category"
        />
            <label htmlFor="stock">Stock</label>
        <input
          type="number"
          name="stock"
          value={formData.stock}
          onChange={handleChange}
          placeholder="Stock"
        />
            <label htmlFor="price">Price</label>
        <input
          type="number"
          name="price"
          value={formData.price}
          onChange={handleChange}
          placeholder="Price"
        />
        <label htmlFor="description">Description</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              prescription: e.target.value === "required",
            }))
          }
          placeholder="Description"
        />
           <label htmlFor="prescription">Prescription</label>
        <select
          name="prescription"
          value={formData.prescription ? "required" : "not_required"}
          onChange={handleChange}
        >
          <option value="required">Prescription Required</option>
          <option value="not_required">No Prescription</option>
        </select>
        <label htmlFor="image">Image</label>
        <input type="file" accept="image/*" onChange={handleFileChange} />
        <button type="submit">Update Medicine</button>
      </form>
      <button onClick={closeModal}>Close</button>
    </div>
  );
};

export default UpdateMedicineForm;
